import {
  Module, VuexModule, Action, Mutation,
} from 'vuex-module-decorators';
import PimcoreEntityIntrospection from '@/classes/graphql-introspection/PimcoreEntityIntrospection';
import ApolloClient from 'apollo-client';
import GetIntrosepctionQuery from '@/graphql/GetIntrospectionQuery.gql';
import { defaultApolloClient } from '@/vue-apollo';
import GraphQLFieldsExtractor from '@/classes/graphql-introspection/GraphQLFieldsExtractor';
import PimcoreSystemFieldsExcluder from '@/classes/graphql-introspection/PimcoreSystemFieldsExcluder';
import { GraphQLIntrospectionModule, IntrospectionQuery } from './types';

@Module({ namespaced: true, name: 'graphQLIntrospection' })
export default class GraphQLIntrospection extends VuexModule<any, any> implements GraphQLIntrospectionModule {
  introspectionQuery: IntrospectionQuery | null = null;

  @Mutation
  setIntrospectionQuery(introspectionQuery: IntrospectionQuery): void {
    this.introspectionQuery = introspectionQuery;
  }

  @Action({ commit: 'setIntrospectionQuery' })
  async fetchIntrospectionQuery(apolloClient: ApolloClient<any> = defaultApolloClient): Promise<IntrospectionQuery> {
    const result = await apolloClient.query({
      query: GetIntrosepctionQuery,
    });
    return result.data;
  }

  @Action({ rawError: true })
  async getPimcoreIntrospection(entityName: string): Promise<PimcoreEntityIntrospection> {
    if (!this.context.state.introspectionQuery) {
      await this.context.dispatch('fetchIntrospectionQuery');
    }
    const fieldsExtractor = new GraphQLFieldsExtractor(new PimcoreSystemFieldsExcluder());
    return new PimcoreEntityIntrospection(this.introspectionQuery!, entityName, fieldsExtractor);
  }
}
